// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13ZeU","newExpiryDate":"styles_newExpiryDate__5fc__","footer":"styles_footer__HV-cm"};